module.exports = __webpack_public_path__ + "img/coating-reflection.a7cb37bb.svg";